import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { Colors, Sizes } from '@/components/ui/types';

import Fieldset from '../fieldset';
import { ToggleProps } from './types';

const sizeClasses: Record<Sizes, string> = {
  xs: 'toggle-xs',
  sm: 'toggle-sm',
  md: 'toggle-md',
  lg: 'toggle-lg',
  xl: 'toggle-xl',
};

const colorClasses: Record<Colors, string> = {
  default: '',
  neutral: 'toggle-neutral',
  primary: 'toggle-primary',
  secondary: 'toggle-secondary',
  accent: 'toggle-accent',
  info: 'toggle-info',
  success: 'toggle-success',
  warning: 'toggle-warning',
  error: 'toggle-error',
};

const ToggleBase = forwardRef<HTMLInputElement, ToggleProps>(
  ({ className, size = 'md', color = 'default', ...props }, ref) => {
    const classes = twMerge(
      'toggle',
      sizeClasses[size],
      colorClasses[color],
      className,
    );

    return <input ref={ref} type="checkbox" className={classes} {...props} />;
  },
);

ToggleBase.displayName = 'Toggle';

export const Toggle = Object.assign(ToggleBase, {
  Fieldset,
});
